import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Search from "./pages/Search";
import Random from "./pages/Random";
import Calendar from "./pages/Calendar";
import AdminNew from "./pages/AdminNew";
import AdminEdit from "./pages/AdminEdit";
import ProfilePage from "./pages/profile/[id]";
import RequireAuth from "./components/RequireAuth";
import About from "./pages/About";
import Request from "./pages/Request";
import AdminRequests from "./pages/AdminRequests";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/random" element={<Random />} />
        <Route path="/calendar" element={<Calendar />} />

        <Route
          path="/admin/new"
          element={
            <RequireAuth>
              <AdminNew />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/edit/:id"
          element={
            <RequireAuth>
              <AdminEdit />
            </RequireAuth>
          }
        />

        <Route path="/profile/:id" element={<ProfilePage />} />
        <Route path="/profile" element={<Navigate to="/search" replace />} />
        <Route path="/request" element={<Request />} />
        <Route path="/admin/requests" element={<AdminRequests />} />

        <Route path="/about" element={<About />} />
        <Route path="*" element={<div>Not found</div>} />
      </Routes>
    </Layout>
  );
}
